[
  {
    "code": "SS-EC",
    "name": "Central Equatoria"
  },
  {
    "code": "SS-EE",
    "name": "Eastern Equatoria"
  },
  {
    "code": "SS-JG",
    "name": "Jonglei"
  },
  {
    "code": "SS-LK",
    "name": "Lakes"
  },
  {
    "code": "SS-BN",
    "name": "Northern Bahr el Ghazal"
  },
  {
    "code": "SS-UY",
    "name": "Unity"
  },
  {
    "code": "SS-NU",
    "name": "Upper Nile"
  },
  {
    "code": "SS-WR",
    "name": "Warrap"
  },
  {
    "code": "SS-BW",
    "name": "Western Bahr el Ghazal"
  },
  {
    "code": "SS-EW",
    "name": "Western Equatoria"
  }
]